import type { ComponentStyleConfig } from '@chakra-ui/react';

export const FormError: ComponentStyleConfig = {
  baseStyle: {
    text: {
      margin: 0,
      padding: 0,
      fontSize: 'sm',
      fontWeight: 400,
    },
  },
};
